module.exports = __webpack_public_path__ + "static/media/whzy.32456e17.jpg";